<template>
  <section>
    main
  </section>
</template>

<script>
export default {}
</script>

<style scoped></style>
